import { render } from "./SaveCompany.vue?vue&type=template&id=1fa59d5a"
import script from "./SaveCompany.vue?vue&type=script&lang=js"
export * from "./SaveCompany.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\hrportal\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__